"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4858],{

/***/ 4858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N0": function() { return /* binding */ VideoTestimonial; },
/* harmony export */   "gQ": function() { return /* binding */ tesimonialDataDict; },
/* harmony export */   "rX": function() { return /* binding */ VideoTestimonialsContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62469);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5276);
/* harmony import */ var react_snaplist_carousel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97905);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23004);
/* harmony import */ var _components_workout_player_video_player__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97685);
/* harmony import */ var _lib_gtag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61474);
/* harmony import */ var _lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93335);












var Michael = {
    file: "Michael",
    name: "Michael L.",
    url: "https://stream.mux.com/MpDbGRCtFJNqcg73oUSC8102xLyMka8l5JQ01ZYrsgehk.m3u8",
    testimony: "My coach in my ear pushing me to be better, not just physically, but mentally day in day out."
};
var Michelle = {
    file: "Michelle",
    name: "Michelle H.",
    url: "https://stream.mux.com/DcZlnZ3AzBTlUgN8VymbFCk2FW3KbWEOwp8TFe4MH3U.m3u8",
    testimony: "I needed structure in my life, I need someone to tell me what to do."
};
var Ross = {
    file: "Ross",
    name: "Ross B.",
    url: "https://stream.mux.com/W02F01MLAP8Cjmf1tiBIWyBhswNWx01k6E8TPHlzwxOqZg.m3u8",
    testimony: "It helps me be consistent. I have a coach in my ear, telling me what to do."
};
var Liz = {
    file: "Liz",
    name: "Liz W.",
    url: "https://stream.mux.com/nT02wyveTXA02Gs8zZtvj1DOIlR029gLHRy802196UEjOjM.m3u8",
    testimony: "Do the workout like it is. It’s there for a reason. It’s programed."
};
var CC = {
    file: "CC",
    name: "CC A.",
    url: "https://stream.mux.com/zCGztVW5gjSj1BnR00jkwa8ebew02AYns3WGPlAY3mhFk.m3u8",
    testimony: "Honestly from the first workout I was like this is it. This is addictive, this is fun, this is very beneficial."
};
var Kelly = {
    file: "Kelly",
    name: "Kelly C.",
    url: "https://stream.mux.com/nG7qWqwEr6H5JV3018Z2Q7LJt02MomASR00SmGBjBSHByI.m3u8",
    testimony: "Gave me the confidence to go to the gym, I know what to do now"
};
var tesimonialDataDict = {
    Michael: Michael,
    Michelle: Michelle,
    Ross: Ross,
    Kelly: Kelly,
    CC: CC,
    Liz: Liz
};
var desktopTesimonialData = [
    Michael,
    Michelle,
    Ross,
    Kelly,
    CC,
    Liz
];
var mobileTesimonialData = [
    Michelle,
    Michael,
    Kelly,
    Ross,
    Liz,
    CC
];
var PlayButton = function(param) {
    var visible = param.visible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("center p-6 bg-white bg-opacity-50 border-4 border-white rounded-full", {
            "opacity-50": !visible
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            className: "w-10 h-10 translate-x-1 lg:w-12 lg:h-12 tranform",
            viewBox: "0 0 49 55",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.77674 54.0771C7.18112 54.0771 8.43609 53.693 10.199 52.6883L44.651 32.919C47.3104 31.3824 48.8641 29.7866 48.8641 27.3044C48.8641 24.8221 47.3104 23.256 44.651 21.6898L10.199 1.92052C8.43609 0.915803 7.18112 0.531647 5.77674 0.531647C2.87836 0.531647 0.338531 2.71838 0.338531 6.47129V48.1375C0.338531 51.8904 2.87836 54.0771 5.77674 54.0771Z",
                fill: "white"
            })
        })
    });
};
var ContentOverlay = function(param) {
    var visible = param.visible, content = param.content, onClick = param.onClick, videoState = param.videoState, buffering = param.buffering, duration = param.duration, initiallyMuted = param.initiallyMuted, muted = param.muted;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onClick,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute bg-black inset-0 flex flex-col items-center justify-between cursor-pointer", {
            "bg-opacity-0": visible,
            "bg-opacity-40": !visible
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-32"
            }),
            initiallyMuted && muted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SpeakerOffIcon */ .gQ8, {
                className: "absolute w-6 h-6 text-white left-4 top-4"
            }) : initiallyMuted && !muted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SpeakerLoudIcon */ .bx5, {
                className: "absolute w-6 h-6 text-white left-4 top-4"
            }) : null,
            buffering ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                className: "w-10 h-10 text-white animate-spin",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            }) : videoState.paused ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlayButton, {
                visible: visible
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex-col max-w-md p-8 mx-auto space-y-2 text-center center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "text-xl text-white lg:text-2xl heading",
                        children: content.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "italic text-white lg:text-lg opacity-80",
                        children: content.testimony
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    background: "linear-gradient(0deg, rgba(0, 0, 0, 0.78) 45.41%, rgba(0, 0, 0, 0) 91.64%)"
                },
                className: "absolute bottom-0 w-full h-48 transform"
            }),
            duration || videoState.duration ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "absolute inset-x-0 bottom-0 w-auto h-1 transform",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute w-full h-full bg-white rounded-lg opacity-10"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.div */ .E.div, {
                        className: "absolute h-full bg-white rounded-lg opacity-75",
                        style: {
                            width: "".concat(100 * videoState.time / (duration || videoState.duration), "%")
                        }
                    })
                ]
            }) : null
        ]
    });
};
var VideoTestimonial = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo(function(param) {
    var content = param.content, onClick = param.onClick, visible = param.visible, handleVideoEnded = param.handleVideoEnded, shouldAutoPlay = param.shouldAutoPlay, _autoPlay = param.autoPlay, autoPlay = _autoPlay === void 0 ? false : _autoPlay, tmp = param.muted, initiallyMuted = tmp === void 0 ? false : tmp;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initiallyMuted), muted = ref[0], setMuted = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), duration = ref1[0], setDuration = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_workout_player_video_player__WEBPACK_IMPORTED_MODULE_5__/* .VideoPlayer */ .Y, {
        className: "w-full h-full max-w-full mx-auto shadow-xl rounded-xl",
        url: !!content.url ? content.url : "https://media.teams.joinladder.com/website/videos/testimonials/".concat(content.file, ".mp4"),
        poster: "https://media.teams.joinladder.com/website/videos/testimonials/posters/".concat(content.file, ".png"),
        autoPlay: autoPlay,
        muted: muted,
        loop: false,
        controls: false,
        playsInline: true
    })), 4), video = ref2[0], videoState = ref2[1], videoControls = ref2[2], videoRef = ref2[3];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (shouldAutoPlay && visible) {
            videoControls.play();
        }
    }, [
        visible,
        shouldAutoPlay,
        videoControls
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, ref1;
        videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.addEventListener) === null || ref1 === void 0 ? void 0 : ref1.call(ref, "loadedmetadata", function() {
            var ref;
            setDuration(videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.duration);
        });
        videoRef.current.onended = handleVideoEnded;
    }, []);
    var buffering = function() {
        var ref;
        if (videoState.paused) return false;
        var buffered = (ref = videoState.buffered) === null || ref === void 0 ? void 0 : ref[0];
        if (!(buffered === null || buffered === void 0 ? void 0 : buffered.end)) return true;
        if (videoState.time >= (buffered === null || buffered === void 0 ? void 0 : buffered.end)) return true;
        return false;
    };
    var toggle = function() {
        onClick();
        (0,_lib_gtag__WEBPACK_IMPORTED_MODULE_11__/* .event */ .B)({
            action: "Customer_Testimonial_Clicked",
            category: "Customer_Testimonial",
            label: content.name,
            value: videoState.time
        });
        if (videoState.paused) {
            setMuted(false);
            return videoControls.play();
        }
        if (initiallyMuted) {
            return setMuted(function(muted) {
                return !muted;
            });
        }
        videoControls.pause();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!visible) {
            videoControls.pause();
        }
    }, [
        visible
    ]);
    var observe = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
        onLeave: function() {
            videoControls.pause();
        }
    }).observe;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: observe,
            onClick: toggle,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("overflow-hidden rounded-xl min-w-fit snap-center w-full relative"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.div */ .E.div, {
                className: "overflow-hidden cursor-pointer rounded-xl",
                initial: visible ? "visible" : "shrunken",
                animate: visible ? "visible" : "shrunken",
                variants: {
                    shrunken: {
                        scale: 0.95
                    },
                    visible: {
                        scale: 1
                    }
                },
                children: [
                    video,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentOverlay, {
                        duration: duration,
                        videoState: videoState,
                        visible: visible,
                        content: content,
                        buffering: buffering(),
                        initiallyMuted: initiallyMuted,
                        muted: muted
                    })
                ]
            })
        })
    });
});
var VideoTestimonialsContainer = function() {
    var snapList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), indexToAutoPlay = ref[0], setIndexToAutoPlay = ref[1];
    var visible = (0,react_snaplist_carousel__WEBPACK_IMPORTED_MODULE_4__/* .useVisibleElements */ .Nl)({
        debounce: 10,
        ref: snapList
    }, function(elements) {
        switch(elements.length){
            case 1:
                return elements[0];
            case 2:
            case 3:
                return elements[1];
            default:
                return elements[0];
        }
    });
    var goToSnapItem = (0,react_snaplist_carousel__WEBPACK_IMPORTED_MODULE_4__/* .useScroll */ .vO)({
        ref: snapList
    });
    var isMobile = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_6__/* .useIsMobile */ .dD)();
    var observe = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
        threshold: 0.5,
        onEnter: function(param) {
            var unobserve = param.unobserve;
            if (!isMobile) {
                goToSnapItem(1, {
                    animationEnabled: true
                });
                unobserve();
            }
        }
    }).observe;
    var itemArray = isMobile ? mobileTesimonialData : desktopTesimonialData;
    var handleVideoEnded = function(index) {
        return function() {
            var nextIndex;
            if (index === itemArray.length - 1) {
                nextIndex = 0;
            } else {
                nextIndex = index + 1;
            }
            setIndexToAutoPlay(nextIndex);
            goToSnapItem(nextIndex, {
                animationEnabled: true
            });
            setTimeout(function() {
                setIndexToAutoPlay();
            }, 1000);
        };
    };
    var getMargin = function(i, n) {
        if (i === n) return {
            left: "12px",
            right: "40vw"
        };
        if (i === 0) return {
            left: "40vw",
            right: "12px"
        };
        return {
            left: "12px",
            right: "12px"
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pb-12 space-y-12",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "px-2 space-y-8 lg:px-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative max-w-full mx-auto lg:w-44 w-36",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/assets/award-thing.svg",
                                className: "block w-full mx-auto",
                                alt: "womans health award"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    background: "linear-gradient(180deg, rgba(14, 14, 14, 0) 7.01%, #0E0E0E 69.3%)"
                                },
                                className: "absolute bottom-0 w-full h-12 lg:h-16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-3xl text-center text-white uppercase lg:text-5xl heading",
                        children: "WHAT PEOPLE LIKE YOU ARE SAYING"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-full mx-auto",
                ref: observe,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_snaplist_carousel__WEBPACK_IMPORTED_MODULE_4__/* .SnapList */ .fZ, {
                    direction: "horizontal",
                    className: "overscroll-x-contain",
                    ref: snapList,
                    children: itemArray.map(function(content, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_snaplist_carousel__WEBPACK_IMPORTED_MODULE_4__/* .SnapItem */ .zd, {
                            margin: getMargin(index, itemArray.length - 1),
                            snapAlign: "center",
                            className: "w-11/12 md:w-1/2 lg:w-1/3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoTestimonial, {
                                onClick: function() {
                                    return goToSnapItem(index, {
                                        animationEnabled: true
                                    });
                                },
                                handleVideoEnded: handleVideoEnded(index),
                                shouldAutoPlay: indexToAutoPlay === index,
                                visible: visible === index,
                                content: content
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container mx-auto space-x-2 center",
                children: itemArray.map(function(_, index) {
                    var isActive = visible === index;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return goToSnapItem(index);
                        },
                        style: {
                            background: isActive ? "#E1E1E1" : "#545454"
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("z-10 w-3 lg:w-4 h-3 lg:h-4 pointer text-center list-none rounded-full")
                    }, index);
                })
            })
        ]
    });
};


/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ VideoPlayer; }
});

// UNUSED EXPORTS: VideoPlayerWrapper

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./lib/use-hls-media.js


var checkIsHlsMedia = function(url) {
    if (!url) return false;
    var extension = (0,lodash.last)(url.split("."));
    return extension === "m3u8";
};
var useHlsMedia = function(param) {
    var _autoPlay = param.autoPlay, autoPlay = _autoPlay === void 0 ? false : _autoPlay, url = param.url, playerRef = param.ref;
    var handleHlsError = function handleHlsError(event, data) {
        if (typeof Hls.current === "undefined") return;
        switch(data.type){
            case Hls.current.ErrorTypes.NETWORK_ERROR:
                // try to recover network error
                // hls.current.startLoad();
                setRetryAttempts(function(n) {
                    if (n < 25) {
                        setTimeout(function() {
                            return hls.current.recoverMediaError();
                        }, n * 0.5 * 1000);
                    }
                    return n + 1;
                });
                break;
            case Hls.current.ErrorTypes.MEDIA_ERROR:
                hls.current.recoverMediaError();
                break;
            default:
                // cannot recover
                setError(true);
                hls.current.destroy();
                break;
        }
    };
    var ref = (0,react.useState)(0), retryAttempts = ref[0], setRetryAttempts = ref[1];
    var ref1 = (0,react.useState)(true), isSupported = ref1[0], setIsSupported = ref1[1];
    var ref2 = (0,react.useState)(checkIsHlsMedia(url)), isHlsMedia = ref2[0], setIsHlsMedia = ref2[1];
    var ref3 = (0,react.useState)(null), error = ref3[0], setError = ref3[1];
    var Hls = (0,react.useRef)();
    var hls = (0,react.useRef)();
    (0,react.useEffect)(function() {
        Hls.current = window.Hls;
        hls.current = new window.Hls();
    }, []);
    var cleanUpHls = function() {
        var ref, ref1;
        (ref = hls.current) === null || ref === void 0 ? void 0 : (ref1 = ref.destroy) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
    };
    (0,react.useEffect)(function() {
        setIsHlsMedia(checkIsHlsMedia(url));
    }, [
        url
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (typeof Hls.current === "undefined") return;
        var isHlsMedia = checkIsHlsMedia(url);
        if (!playerRef.current) {
            return;
        }
        if (!url) {
            return;
        }
        if (!isHlsMedia) {
            return;
        }
        if (!Hls.current.isSupported()) {
            return setIsSupported(false);
        }
        setIsSupported(true);
        hls.current.attachMedia(playerRef.current);
        hls.current.on(Hls.current.Events.MEDIA_ATTACHED, function() {
            hls.current.loadSource(url);
        });
        hls.current.on(Hls.current.Events.MANIFEST_PARSED, function(event, data) {
            setError(false);
            if (autoPlay) {
                playerRef.current.play();
            }
        });
        hls === null || hls === void 0 ? void 0 : (ref = hls.on) === null || ref === void 0 ? void 0 : ref.call(hls, Hls.current.Events.ERROR, handleHlsError);
        return function() {
            hls.current.destroy();
        };
    }, [
        playerRef,
        url,
        autoPlay
    ]);
    return {
        error: error,
        playerRef: playerRef,
        isSupported: isSupported,
        isHlsMedia: isHlsMedia,
        cleanUpHls: cleanUpHls
    };
};

;// CONCATENATED MODULE: ./components/workout/player/video-player.js






var VideoPlayerWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: "absolute inset-0 flex-center bg-storm-900",
        style: {
            width: 440
        },
        children: children
    });
};
var HlsVideoPlayer = function(_param) {
    var url = _param.url, playerRef = _param.playerRef, _autoPlay = _param.autoPlay, autoPlay = _autoPlay === void 0 ? true : _autoPlay, _loop = _param.loop, loop = _loop === void 0 ? true : _loop, _controls = _param.controls, controls = _controls === void 0 ? false : _controls, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "url",
        "playerRef",
        "autoPlay",
        "loop",
        "controls"
    ]);
    useHlsMedia({
        ref: playerRef,
        url: url
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", (0,_object_spread/* default */.Z)({
        ref: playerRef,
        src: url,
        width: "440",
        height: "auto",
        autoPlay: autoPlay,
        controls: controls,
        loop: loop
    }, rest));
};
var VideoPlayer = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwarededRef) {
    var _autoPlay = _param.autoPlay, autoPlay = _autoPlay === void 0 ? true : _autoPlay, _loop = _param.loop, loop = _loop === void 0 ? true : _loop, _controls = _param.controls, controls = _controls === void 0 ? false : _controls, url = _param.url, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "autoPlay",
        "loop",
        "controls",
        "url"
    ]);
    var ref = (0,react.useRef)();
    if (forwarededRef) {
        ref = forwarededRef;
    }
    var isHlsMedia = checkIsHlsMedia(url);
    if (isHlsMedia) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HlsVideoPlayer, (0,_object_spread/* default */.Z)({
            loop: loop,
            url: url,
            playerRef: ref,
            autoPlay: autoPlay,
            controls: controls
        }, rest));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        loop: loop,
        width: "440",
        height: "auto",
        autoPlay: autoPlay,
        controls: controls,
        ref: ref
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                src: url,
                type: "video/mp4"
            }),
            "Your browser does not support the video tag."
        ]
    }));
});


/***/ })

}]);